import React, { useEffect, useState } from "react";
import AppShell from "../components/AppShell";
import api from "../lib/api";
import { Beef, Dumbbell, Utensils } from "lucide-react";

export default function MuscleGain() {
  const [profile, setProfile] = useState(null);
  useEffect(() => { api.get("/profile").then((r) => setProfile(r.data)).catch(() => {}); }, []);

  return (
    <AppShell title="Ganar masa muscular" subtitle="4 comidas al día, más proteína, carbohidratos saludables y entrenamiento de fuerza.">
      <div className="grid lg:grid-cols-3 gap-6">
        <Pillar icon={Beef} title="Más proteína" desc="1.6-2.2 g por kg de peso corporal. Reparte en 4 comidas." />
        <Pillar icon={Utensils} title="Más carbohidratos" desc="Arroz, avena, papa, plátano, pasta integral. Pre y post-entreno." />
        <Pillar icon={Dumbbell} title="Fuerza progresiva" desc="4-5 días/semana. Compuestos: sentadilla, press, peso muerto, dominadas." />

        <div className="lg:col-span-3 mep-card p-6">
          <h2 className="font-display text-2xl font-light tracking-tight mb-5">Ejemplo de día</h2>
          <div className="grid md:grid-cols-2 gap-6">
            <PlanBlock
              title="Plan para mujer (2000-2400 kcal)"
              items={[
                "08:00 — Avena + 1 scoop proteína + plátano + nueces",
                "12:00 — Pollo + arroz integral + brócoli + aguacate",
                "16:00 — Batido proteico + tostada con mantequilla almendras",
                "20:00 — Salmón + boniato + espinacas salteadas",
                "Entrenamiento: 4 días fuerza + 1 día glúteos enfocado",
              ]}
            />
            <PlanBlock
              title="Plan para hombre (2800-3300 kcal)"
              items={[
                "07:00 — 4 huevos + avena + leche + plátano",
                "12:00 — Pechuga 200 g + arroz + frijoles + tortillas",
                "16:00 — Atún + pasta integral + ensalada + aceite oliva",
                "20:00 — Carne magra + boniato + verduras",
                "Entrenamiento: 5 días fuerza (push/pull/piernas)",
              ]}
            />
          </div>
          {profile?.goal === "ganar_masa" && (
            <div className="mt-6 p-4 rounded-lg bg-[rgba(232,61,132,0.08)] border-l-2 border-[var(--mep-pink)]">
              <p className="text-sm">
                <b>Hola {profile.name}:</b> con tu objetivo de ganar masa muscular y peso actual de {profile.weight_kg} kg,
                apunta a un superávit de ~300 kcal/día y prioriza descanso (8h de sueño).
              </p>
            </div>
          )}
        </div>
      </div>
    </AppShell>
  );
}

const Pillar = ({ icon: Icon, title, desc }) => (
  <div className="mep-card p-6">
    <div className="w-12 h-12 rounded-full bg-[rgba(212,175,55,0.12)] border border-[var(--mep-gold)]/40 flex items-center justify-center text-[var(--mep-gold)] mb-4">
      <Icon size={20} />
    </div>
    <h3 className="font-display text-xl font-medium tracking-tight">{title}</h3>
    <p className="text-sm text-[var(--mep-text-muted)] mt-2 leading-relaxed">{desc}</p>
  </div>
);

const PlanBlock = ({ title, items }) => (
  <div className="bg-[var(--mep-surface-2)] rounded-lg p-5 border-l-2 border-[var(--mep-gold)]">
    <h3 className="font-display text-lg font-medium tracking-tight mb-3">{title}</h3>
    <ul className="space-y-2 text-sm">
      {items.map((it, i) => <li key={i} className="text-[var(--mep-text-muted)]">{it}</li>)}
    </ul>
  </div>
);
